import * as types from './mutation-types'

// 权限菜单
export const setPermissions = ({ commit }, permissions) => {
	commit(types.SET_PERMISSIONS, permissions)
}